import { RadioSegments, type SegmentOption } from '@/components/ui/SegmentedControl'
import { TOUCH_TARGET_Y } from '@/components/ui/button-variants'
import { cn } from '@/lib/utils'

/**
 * A two-way choice in the chart head's toggle skin (ChartTypeToggle's: the inset track under a
 * hairline, the choice lifted onto a popover thumb), for the views' own pairs: Line / Area, and
 * the heatmap's Size by.
 */
export default function SegmentToggle<T extends string>({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}: {
  options: readonly SegmentOption<T>[]
  value: T
  onChange: (value: T) => void
  ariaLabel: string
  className?: string
}) {
  return (
    <RadioSegments
      options={options}
      value={value}
      onChange={onChange}
      ariaLabel={ariaLabel}
      thumbSpeed="med"
      thumbClassName="border-border bg-popover"
      className={cn(
        'inline-grid shrink-0 auto-cols-fr grid-flow-col border border-border-subtle bg-muted p-1',
        className,
      )}
      segmentClassName={(checked) =>
        cn(
          'relative inline-flex h-7 items-center justify-center border border-transparent px-3 text-body-xs whitespace-nowrap transition-colors',
          TOUCH_TARGET_Y,
          checked
            ? 'text-h-xs text-foreground'
            : 'text-muted-foreground hover:text-foreground focus-visible:text-foreground',
        )
      }
    />
  )
}
